import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
var REQUEST_KEY = "updatePaymentMethod";
var useUpdatePaymentMethod = function () {
    var dispatch = useDispatch();
    var loading = useSelector(function (state) { var _a; return (_a = state.CustomRequest.loadingCustomRequest[REQUEST_KEY]) !== null && _a !== void 0 ? _a : false; });
    var data = useSelector(function (state) { var _a; return (_a = state.CustomRequest.dataCustomRequest[REQUEST_KEY]) !== null && _a !== void 0 ? _a : null; });
    var error = useSelector(function (state) { var _a; return (_a = state.CustomRequest.errorCustomRequest[REQUEST_KEY]) !== null && _a !== void 0 ? _a : null; });
    var updatePaymentMethod = function (policyId, body) {
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "PATCH",
            path: "/asg/Api/V1/Policy/".concat(policyId, "/Payment-Method"),
            body: { data: body },
        }));
    };
    var clearUpdatePaymentMethod = function () {
        dispatch(clearCustomRequest(REQUEST_KEY));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        updatePaymentMethod: updatePaymentMethod,
        clearUpdatePaymentMethod: clearUpdatePaymentMethod,
        loadingUpdatePaymentMethod: loading,
        responseUpdatePaymentMethod: data,
        errorUpdatePaymentMethod: error,
    };
};
export default useUpdatePaymentMethod;
